import { ConversationAuditLogEntry } from 'apis/auditLogs';

import { getLogEntryAuthorName, LogEntry } from './logEntry';
import { UserLink } from './userLink/userLink';

type ConversationUnassignedProps = {
  entry: ConversationAuditLogEntry<'CONVERSATION_UNASSIGNED'>;
};

export const ConversationUnassigned = ({
  entry,
}: ConversationUnassignedProps): JSX.Element => {
  const agentName = getLogEntryAuthorName({
    ...entry,
    author: entry.agent,
  });

  const agentLink = <UserLink userId={entry.agent.id}>{agentName}</UserLink>;

  const text = <>Conversation is unassigned from {agentLink}</>;

  return <LogEntry entry={entry} text={text} />;
};
